function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "41",
  height: "58",
  viewBox: "0 0 41 58",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), React.createElement("defs", null, React.createElement("path", {
  id: "shaker-path-1",
  d: "M.001 1h40.205v57.647H.001z"
})), React.createElement("g", {
  transform: "translate(0 -1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "shaker-mask-2",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#shaker-path-1"
})), React.createElement("path", {
  d: "M37.07 49.482l-8.313-22.896a1.36 1.36 0 00-1.926-.732l-14.985 8.172a1.36 1.36 0 00-.435 2.02l14.763 19.4 10.896-5.964zM7.574 14.613l1.743 15.25a1.362 1.362 0 001.998 1.043l13.215-7.22a1.357 1.357 0 00.234-2.233l-11.646-9.909-5.544 3.07zM4.01 8.547l1.719 3.192a.599.599 0 00.81.243l4.914-2.727a.602.602 0 00.243-.813L9.98 5.256a.597.597 0 00-.813-.243L4.256 7.74a.594.594 0 00-.246.807zm34.926 43.338l-11.772 6.432a2.368 2.368 0 01-1.152.294 2.403 2.403 0 01-1.914-.942L7.7 36.174a4.944 4.944 0 01-.99-2.457L4.826 17.08a5.092 5.092 0 00-.594-1.88l-2.601-4.74L.116 7.652a.955.955 0 01.387-1.296l9.564-5.24a.953.953 0 011.293.384l4.404 7.92c.297.527.68.998 1.14 1.391l12.627 10.84a4.98 4.98 0 011.44 2.084l9.096 25.203a2.429 2.429 0 01-1.131 2.946zm-25.914-4.362a1.499 1.499 0 10-2.77 1.146l3.75 9.051a1.5 1.5 0 001.96.813 1.502 1.502 0 00.81-1.962l-3.75-9.048zm-7.764-4.845a1.5 1.5 0 00-2.772 1.15l3.747 9.053a1.499 1.499 0 001.959.81 1.501 1.501 0 00.813-1.959l-3.747-9.054zm26.36-25.71a1.501 1.501 0 001.96.813 1.502 1.502 0 00.81-1.962l-3.75-9.048a1.495 1.495 0 00-1.96-.813 1.502 1.502 0 00-.81 1.962l3.75 9.048zM20.103 3.075a1.497 1.497 0 01.81-1.959 1.503 1.503 0 011.962.81l3.747 9.054a1.501 1.501 0 01-2.772 1.15l-3.747-9.055z",
  fill: "currentColor",
  mask: "url(#shaker-mask-2)"
}))));